(function (global, factory) {
    "use strict";
    if ("function" === typeof define && define.amd) {
        // If supports for AMD is available return the value to the AMD Loader
        // and to the global (window) object in case any JS module is expecting
        // the AppNexusModule to exists on the window object.
        define([], function () {
            factory(global);
        });
    } else {
        // If not support for AMD or Common JS is available register the module in the global scope.
        factory(global);
    }
}("undefined" !== typeof window ? window : {},
    function (root) {
        "use strict";

        // This module set the keyboard events to any fly-out menus for accessibility, like the mega menu.
        // It requires specific html data structure and data attributes to work:
        // -Main menu container must have a "data-is-menu" data attribute.
        // -Hidden submenus must contain a "data-is-submenu" data attribute.
        // -Elements that open its respective submenus must be anchors with a "data-opens-submenu" data attribute,
        //  immediately follow by the "data-is-submenu" submenu container element.

        var ESCAPE_KEY_CODE = 27;
        var TAB_KEY_CODE = 9;

        /**
         * Shows or hides submenu sections for menu options that have submenus.
         * @param {object} mainMenu The main menu container element.
         */
        var onEnterKeyToggleMenu = function (mainMenu) {
            var submenuContainers = mainMenu.querySelectorAll("[data-opens-submenu]");

            for (var i = 0; i < submenuContainers.length; ++i) {
                var currentSubmenuContainer = submenuContainers[i];
                currentSubmenuContainer.addEventListener("click", function (event) {
                    event.preventDefault();

                    var submenu = this.parentNode.querySelector("[data-is-submenu]");

                    if (submenu.style.display === "" || submenu.style.display === "none") {
                        submenu.style.display = "block";
                        this.setAttribute("aria-expanded", "true");
                    } else {
                        submenu.style.display = "none";
                        this.setAttribute("aria-expanded", "false");
                    }
                });
            }
        }

        /**
         * Closes the current open submenu when hitting the escape key in the keyboard.
         * @param {object} mainMenu The main menu container element.
         */
        var onEscapeKeyCloseMenu = function (mainMenu) {
            var submenus = mainMenu.querySelectorAll("[data-is-submenu]");

            for (var i = 0; i < submenus.length; ++i) {
                var currentSubmenu = submenus[i];
                currentSubmenu.addEventListener("keydown", function (event) {
                    if (event.keyCode === ESCAPE_KEY_CODE) {
                        var submenu = this.closest("[data-is-submenu]");
                        var submenuContainer = submenu.parentNode.querySelector("[data-opens-submenu]");

                        submenu.style.display = "none";
                        submenuContainer.setAttribute("aria-expanded", "false");
                        submenuContainer.focus();
                    }
                });
            }
        }

        /**
         * Hides the current open/active submenu.
         * @param {object} submenu The visible submenu element to close/hide.
         */
        var closeSubmenu = function(submenu) {
            var submenuContainer = submenu.parentNode.querySelector("[data-opens-submenu]");

            submenu.style.display = "none";
            submenuContainer.setAttribute("aria-expanded", "false");
        }
        
        /**
         * Closes the submenu when navigating it with keyboard:
         * 1- When the focus is in the first actionable element of the submenu and the user hits shift+tab.
         * 2- When the user is in the last actionable element of the submenu and the user hits tab.
         * @param {object} mainMenu The main menu container element.
         */
        var onTabCloseSubmenu = function(mainMenu) {
            var submenus = mainMenu.querySelectorAll("[data-is-submenu]");
            for (var i = 0; i < submenus.length; ++i) {
                var currentSubmenu = submenus[i];
                var allSubmenuActionableElements = currentSubmenu.querySelectorAll("a, input");
                var firstActionableElement = allSubmenuActionableElements[0];
                var lastActionableElement = allSubmenuActionableElements[allSubmenuActionableElements.length - 1];

                firstActionableElement.addEventListener("keydown", function(event) {
                    if (event.shiftKey && event.keyCode === TAB_KEY_CODE) {
                        var submenu = this.closest("[data-is-submenu]");
                        closeSubmenu(submenu);
                    }
                });

                lastActionableElement.addEventListener("keydown", function(event) {
                    if (!event.shiftKey && event.keyCode === TAB_KEY_CODE) {
                        var submenu = this.closest("[data-is-submenu]");
                        closeSubmenu(submenu);
                    }
                });
            }
        }

        /**
         * When the focus is in any open submenu options, if the submenu is open and the next tab is going to the submenu, then hides the submenu.
         * @param {object} mainMenu The main menu container element.
         */
        var onBlurSubmenuContainerClose = function (mainMenu) {
            var submenuContainers = mainMenu.querySelectorAll("[data-opens-submenu]");

            for (var i = 0; i < submenuContainers.length; ++i) {
                var currentSubmenuContainer = submenuContainers[i];

                currentSubmenuContainer.addEventListener("blur", function (event) {
                    if (event.relatedTarget &&
                        !event.relatedTarget.closest("[data-is-submenu]")) {
                        var submenu = this.parentNode.querySelector("[data-is-submenu]");

                        submenu.style.display = "none";
                        this.setAttribute("aria-expanded", "false");
                    }
                });
            }
        }

        /**
         * When hovering with the mouse a menu option with the that contains a submenu, opens the submenu.
         * This is normally done with css but if the user was navigating the menu with the keyboard before, then the menu may not display on hover.
         * @param {any} menuElement
         */
        var onMouseEnterOpenMenu = function (menuElement) {
            var submenuContainers = menuElement.querySelectorAll("[data-opens-submenu]");

            for (var i = 0; i < submenuContainers.length; ++i) {
                var currentSubmenuContainer = submenuContainers[i].parentNode;
                currentSubmenuContainer.addEventListener("mouseenter", function () {
                    var submenu = this.querySelector("[data-is-submenu]");

                    submenu.style.display = "block";
                    this.querySelector("[data-opens-submenu]").setAttribute("aria-expanded", "true");

                });
            }
        }

        /**
         * When hovering with the mouse a menu option with the that contains a submenu, closes the submenu.
         * This is normally done with css but if the user was navigating the menu with the keyboard before, then the submenu may not hide.
         * @param {any} menuElement
         */
        var onMouseLeaveCloseMenu = function (menuElement) {
            var submenuContainers = menuElement.querySelectorAll("[data-opens-submenu]");

            for (var i = 0; i < submenuContainers.length; ++i) {
                var currentSubmenu = submenuContainers[i].parentNode;
                currentSubmenu.addEventListener("mouseleave", function () {
                    var submenu = this.querySelector("[data-is-submenu]");

                    submenu.style.display = "none";
                    this.querySelector("[data-opens-submenu]").setAttribute("aria-expanded", "true");

                });
            }
        }

        /**
         * Sets all the keyboard events to navigate the header menus with the keyboard.
         */
        var setAllEvents = function () {
            var mainMenus = document.querySelectorAll("[data-is-menu]");

            for (var i = 0; i < mainMenus.length; ++i) {
                var mainMenu = mainMenus[i];

                onEnterKeyToggleMenu(mainMenu);
                onEscapeKeyCloseMenu(mainMenu);
                onTabCloseSubmenu(mainMenu);
                onBlurSubmenuContainerClose(mainMenu);
                onMouseEnterOpenMenu(mainMenu);
                onMouseLeaveCloseMenu(mainMenu);
            }
        }

        setAllEvents();

    }));